<template>
  <b-modal
    id="modal-detail"
    size="md"
    title="Detail Status"
    hide-header-close
    centered
    @hidden="resetModal"
  >
    <div class="mc-control-tower__modal">
      <div class="mc-control-tower__modal-item">
        <b-button
          @click="redirectToLiveview"
          class="position-absolute"
          variant="outline-primary"
          size="sm"
          ><i class="mc-fa icon-outline_paper-plane"></i>{{ $t('tower.trackVehicles') }}</b-button
        >
        <dl class="mc-modal-info__list-detail">
          <dt>{{ $t('global.fleet') }}</dt>
          <dd>
            {{ vehicleStatus?.licensePlate }} / {{ vehicleStatus?.vehicle?.vehicleType.type }} /
            {{ vehicleStatus?.vehicle?.vehicleType.category }}
          </dd>
          <dt>{{ $t('global.object.driver') }}</dt>
          <dd>
            {{
              vehicleStatus?.vehicle?.driver1 != null
                ? vehicleStatus?.vehicle?.driver1.fullname
                : $t('global.text.noDriver')
            }}
          </dd>
          <dt>{{ $t('global.object.driverPhoneNumber') }}</dt>
          <dd>
            {{
              vehicleStatus?.vehicle?.driver1 != null
                ? vehicleStatus?.vehicle?.driver1.phoneNo
                : $t('global.text.noDriver')
            }}
          </dd>
        </dl>
      </div>
      <div
        class="mc-control-tower__modal-item"
        v-if="vehicleStatus?.controlTowerData?.alerts.length"
      >
        <span class="blue-500 position-absolute" v-if="phaseOneShow">{{
          $t('tower.alertHistory')
        }}</span>
        <h5>{{ $t('global.object.alert') }}</h5>
        <div class="mc-control-tower__modal-btngroup">
          <b-button
            variant="outline-danger"
            size="sm"
            v-for="(row, index) in vehicleStatus.controlTowerData?.alerts"
            :key="index"
            >{{
              $i18n.locale === 'id' ? row.alert?.descriptionIdn : row.alert?.descriptionEng
            }}</b-button
          >
        </div>
      </div>
      <div class="mc-control-tower__modal-item">
        <div class="position-absolute">
          <b-button
            v-if="!isActive"
            variant="primary"
            size="sm"
            @click="isActive = true"
            :disabled="loading"
          >
            <i class="mc-fa icon-outline_layout"></i> {{ $t('global.viewSetting') }}
          </b-button>
          <template v-else>
            <b-button variant="outline-primary" class="me-2" size="sm" @click="cancel">
              <i class="mc-fa icon-outline_close"></i> {{ $t('global.cancel') }}
            </b-button>
            <b-button variant="primary" size="sm" @click="onSubmit" :disabled="loading">
              <i class="mc-fa icon-outline_save"></i> {{ $t('global.save') }}
            </b-button>
          </template>
        </div>
        <h5>{{ $t('global.viewSensors') }}</h5>
        <p class="text-muted">{{ $t('tower.maxMessage') }}</p>
        <dl class="mc-control-tower__modal-dl">
          <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-')} "
              :label="`${this.$t('liveView.infoWindow.fuel')} (%)`"
              value="fuelPercentage"
              :disabled="disabledCheck('fuelPercentage')"
            />
          </dt>
          <dd>: {{ vehicleStatus?.fuelFiltered }}%</dd>
          <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-L"
              :label="`${this.$t('liveView.infoWindow.fuel')} (L)`"
              value="fuelTotal"
              :disabled="disabledCheck('fuelTotal')"
            />
          </dt>
          <dd>
            :
            {{
              `${((vehicleStatus?.fuelCapacity * vehicleStatus?.fuelFiltered) / 100).toFixed(
                2
              )} ${this.$t('dashboard.object.liter')}`
            }}
          </dd>
          <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-distanceTraveled"
              :label="`${this.$t('liveView.infoWindow.distanceTraveled')}`"
              value="mileage"
              :disabled="disabledCheck('mileage')"
            />
          </dt>
          <dd>: {{ `${vehicleStatus?.sumDistance}Km` }}</dd>
          <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-speed"
              :label="`${this.$t('liveView.infoWindow.speed')}`"
              value="speed"
              :disabled="disabledCheck('speed')"
            />
          </dt>
          <dd>: {{ `${vehicleStatus?.calculatedSpeed}Km/${this.$t('global.time.hours')}` }}</dd>
          <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-machine"
              :label="this.$t('global.alert.machine')"
              value="engine"
              :disabled="disabledCheck('engine')"
            />
          </dt>
          <dd>: {{ vehicleStatus?.engineOn ? 'ON' : 'OFF' }}</dd>
          <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-refrigerator"
              :label="this.$t('master.list.tracker.refrigerator')"
              value="refrigerator"
              :disabled="disabledCheck('refrigerator')"
            />
          </dt>
          <dd>: {{ vehicleStatus?.refrigeratorStatus ? 'ON' : 'OFF' }}</dd>
          <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-door1"
              :label="this.$t('global.alert.door1')"
              value="door1"
              :disabled="disabledCheck('door1')"
            />
          </dt>
          <dd>
            : {{ vehicleStatus?.door1Status ? this.$t('global.closed') : this.$t('global.opened') }}
          </dd>
          <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-door2"
              :label="this.$t('global.alert.door2')"
              value="door2"
              :disabled="disabledCheck('door2')"
            />
          </dt>
          <dd>
            : {{ vehicleStatus?.door2Status ? this.$t('global.closed') : this.$t('global.opened') }}
          </dd>
          <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-pto"
              label="PTO"
              value="pto"
              :disabled="disabledCheck('pto')"
            />
          </dt>
          <dd>
            :
            {{ vehicleStatus?.ptoStatus === null ? '-' : vehicleStatus?.ptoStatus ? 'ON' : 'OFF' }}
          </dd>
          <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-fleetStatus"
              :label="this.$t('global.object.fleetStatus')"
              value="status"
              :disabled="disabledCheck('status')"
            />
          </dt>
          <dd>: {{ motionStatusFormat(vehicleStatus?.calculatedMotionStatus) }}</dd>
          <!-- <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-temp1"
              :label="this.$t('liveView.infoWindow.temp1')"
              value="temp1"
              :disabled="disabledCheck('temp1')"
            />
          </dt>
          <dd>: {{ vehicleStatus?.temperature ? vehicleStatus?.temperature[0] : '-' }}</dd> -->
          <!-- <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-temp2"
              :label="this.$t('liveView.infoWindow.temp2')"
              value="temp2"
              :disabled="disabledCheck('temp2')"
            />
          </dt>
          <dd>: {{ vehicleStatus?.temperature ? vehicleStatus?.temperature[1] : '-' }}</dd> -->
          <!-- <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-temp3"
              :label="this.$t('liveView.infoWindow.temp3')"
              value="temp3"
              :disabled="disabledCheck('temp3')"
            />
          </dt>
          <dd>: {{ vehicleStatus?.temperature ? vehicleStatus?.temperature[2] : '-' }}</dd> -->
          <dt>
            <McCheckbox
              v-model="layouts"
              id="ct-elapsedTime"
              :label="this.$t('liveView.infoWindow.elapsedTime')"
              value="travelTime"
              :disabled="disabledCheck('travelTime')"
            />
          </dt>
          <dd>: {{ vehicleStatus?.sumDriveTimeFormatted }}</dd>
        </dl>
      </div>
    </div>
    <template #modal-footer>
      <div class="mc-modal__filter-footer">
        <div class="d-flex flex-row-reverse">
          <b-button variant="outline-primary" @click="cancelModal()">{{
            $t('global.back')
          }}</b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
import McCheckbox from '@/components/McCheckbox'
import { Helper } from '@/mixin/helper'
import { CTOWER_USER_PLACARDS, UPDATE_CTOWER_USER_PLACARD } from '@/services/api/controltower'

export default {
  components: {
    McCheckbox,
  },
  mixins: [Helper],
  props: {
    item: {
      required: true,
    },
  },
  data() {
    return {
      vehicleStatus: {},
      isActive: false,
      layouts: [],
      oldData: [],
      loading: false,
      needUpdate: true,
      phaseOneShow: false,
    }
  },
  watch: {
    item: {
      handler(val) {
        if (val?.vehicleId) {
          this.vehicleStatus = { ...val }

          if (this.needUpdate) this.getPlacards()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getPlacards() {
      this.loading = true
      const { data } = await this.$apollo.query({
        query: CTOWER_USER_PLACARDS,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            vehicleId: this.vehicleStatus.vehicleId,
          },
        },
      })

      if (data.ctowerUserPlacards.isSuccessful) {
        if (!data.ctowerUserPlacards.ctowerUserPlacards.length) {
          this.loading = false
          return
        }
        this.oldData = data.ctowerUserPlacards.ctowerUserPlacards[0].asArray
        this.layouts = data.ctowerUserPlacards.ctowerUserPlacards[0].asArray.filter(
          (x) => x !== null
        )

        this.loading = false
        this.needUpdate = false
      }
    },

    disabledCheck(param) {
      // const countOfNull = this.layouts.filter((x) => x === null)
      return !this.isActive || (this.layouts.length === 4 && !this.layouts.includes(param))
    },

    cancel() {
      this.isActive = false
      this.layouts = [...this.oldData]
    },

    cancelModal() {
      this.$bvModal.hide('modal-detail')
    },

    resetModal() {
      this.isActive = false
      this.layouts = []
      this.oldData = []
      this.needUpdate = true
    },

    redirectToLiveview() {
      window.location.href = '/liveview-2/?type=vehicle&vehicleId=' + this.vehicleStatus?.vehicleId
    },

    onSubmit() {
      if (!this.layouts.length) {
        return this.$mcToast.warning(this.$t('global.text.noSelected'))
      }

      this.loading = true

      this.$apollo
        .mutate({
          mutation: UPDATE_CTOWER_USER_PLACARD,
          variables: {
            input: {
              oldData: {
                column: this.oldData,
              },
              newData: {
                column: this.layouts,
              },
              vehicleId: this.vehicleStatus.vehicleId,
            },
          },
        })
        .then(({ data }) => {
          if (data.updateCtowerUserPlacard.isSuccessful) {
            this.$emit('onSubmit', this.vehicleStatus.vehicleId, this.layouts)
            this.isActive = false
            this.loading = false
            this.cancelModal()
          }
        })
    },
  },
}
</script>
